import { SVGProps } from "react";

const DotsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="4"
    viewBox="0 0 14 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.60352 3.44531C0.837891 3.44531 0.222656 2.83008 0.222656 2.06445C0.222656 1.29883 0.837891 0.683594 1.60352 0.683594C2.36914 0.683594 2.98438 1.29883 2.98438 2.06445C2.98438 2.83008 2.36914 3.44531 1.60352 3.44531ZM6.7168 3.44531C5.95117 3.44531 5.33594 2.83008 5.33594 2.06445C5.33594 1.29883 5.95117 0.683594 6.7168 0.683594C7.47559 0.683594 8.09766 1.29883 8.09766 2.06445C8.09766 2.83008 7.47559 3.44531 6.7168 3.44531ZM11.8232 3.44531C11.0576 3.44531 10.4424 2.83008 10.4424 2.06445C10.4424 1.29883 11.0576 0.683594 11.8232 0.683594C12.5889 0.683594 13.2041 1.29883 13.2041 2.06445C13.2041 2.83008 12.5889 3.44531 11.8232 3.44531Z"
      fill="white"
    />
  </svg>
);

export default DotsIcon;
